import { Link } from 'react-router-dom';
import './IconWrap.css';

/**
 * Icon action: renders a link when it navigates and a button when it opens a
 * modal — never a link inside a button, which is what it used to do and left an
 * interactive element nested in another one. It applies no styling of its own,
 * so each caller keeps its look (tables use te-action-btn, the navbar keeps
 * te-icon-btn).
 * @param {string} title - Tooltip text, also used as the accessible name.
 * @param {string} [path] - Route to navigate to; ignored when isModal is true.
 * @param {boolean} [isModal] - Whether the action opens a modal instead of navigating.
 */
export const IconWrap = ({ title, className, path, isModal, children, onClick, testId }) => {
  if (!isModal && path) {
    return (
      <Link to={path} className={className} title={title} aria-label={title} data-testid={testId} onClick={onClick}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" className={className} title={title} aria-label={title} onClick={onClick} data-testid={testId}>
      {children}
    </button>
  );
};
